/**
 * @classdesc Latvian Language Pack
 * @desc This class will used to translate tokens into the Latvian language.
 * @namespace Languages.Latvian
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Latvian
 */
export const dictionary = {
    'years'   : 'Gadi',
    'months'  : 'Mēneši',
    'days'    : 'Dienas',
    'hours'   : 'Stundas',
    'minutes' : 'Minūtes',
    'seconds' : 'Sekundes'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Latvian
 */
export const aliases = ['lv', 'lv-lv', 'latvian'];
